module.exports = __webpack_public_path__ + "static/media/heat-map.e01d3790.svg";